export default __webpack_public_path__ + "static/media/endstate-logo.abd92443.png";